import appConfig from "../../../app-config";
import ApiService from "../api.service";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductionReleaseService = {
    dataSourceConfig(url, params) {
        return ApiService.createDataSource(url, params);
    },

    async getPrimaryProductionUM(params) {
        const requestScreenData = {
            url: `api/ProductUnitofMeasure`,
            filter: params.filter,
            select: ["BranchCode", "UnitOfMeasureCode", "ProductCode", "ConversionFactor"],
        };

        return await ApiService.oDataGet(requestScreenData);
    },
    async getNextPalleteNo(WorkOrderCode, ItemCode, BatchNo) {
        const requestScreenData = {
            url: `api/WorkOrder/GetNextPalletNumbeForProductionRelease?WorkOrderCode=${WorkOrderCode}&ItemCode=${ItemCode}`,
        };

        if (BatchNo) {
            requestScreenData.url += `&BatchNo=${BatchNo}`;
        }

        return await ApiService.oDataGet(requestScreenData);
    },

    async reverseProductionRelease(payload) {
        const url = "api/ProductionRelease/Reverse";

        return await ApiService.post(url, payload);
    },

    async saveProductionRelease(url, data) {
        return await ApiService.post("api/" + url, data);
    },


    async getProductionReleaseHeader(Code) {
        const requestScreenData = {
            url: `api/ProductionRelease`,
            filter: `Code eq ${Code}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getReleaseProductByCode(ProductCode, WorkOrderCode, WorkOrderInstance) {
        let url = "api/ProductionReleaseProductList";
        if (WorkOrderInstance !== "Core") {
            url = "api/AlmondcoReleaseSourceProduct?WorkOrderCode=" +
                parseInt(WorkOrderCode) + "&$filter=ProductCode eq '" + ProductCode + "'";
        }
        const requestScreenData = {
            url: url,
            top: 1,
        };

        if (WorkOrderInstance === "Core") {
            requestScreenData.filter = `WorkOrderCode eq ${parseInt(WorkOrderCode)} and ProductCode eq '${ProductCode}'`;
            return await ApiService.oDataGet(requestScreenData);
        } else {
            requestScreenData.filter = `ProductCode eq '${ProductCode}'`;
            return await ApiService.get(url);
        }
    },

    async getWorkOrderPrimaryProduct(WorkOrderCode) {
        const requestScreenData = {
            url: `api/WorkOrderList`,
            filter: `Code eq ${parseInt(WorkOrderCode)} and (FriendlyStatus eq 'Awaiting Production' or FriendlyStatus eq 'In Production' or FriendlyStatus eq 'Review')`,
            select: ["Code", "BranchCode", "Status", "FriendlyStatus", "ProductCode"],
            top: 1
        };

        return await ApiService.oDataGet(requestScreenData);
    },

    async getReleaseFooterTotals(ReleaseFilter, WorkOrderInstance) {
        const requestScreenData = {
            url: `api/ProductionReleaseDetailGrouped`,
            filter: ReleaseFilter
        };

        if (WorkOrderInstance === 'Almondco') {
            requestScreenData.url = 'api/AlmondcoProductionReleaseDetailSummary';
        }

        return await ApiService.oDataGet(requestScreenData);
    },
    async getPrimaryProductDetails(code) {
        const requestScreenData = {
            url: "api/ProductionReleaseProductList",
            top: "1",
            filter: `IsWorkOrderPrimaryProduct eq 'Y' and WorkOrderCode eq ${parseInt(
                code
            )}`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },
}

export { ProductionReleaseService }